// extracted by mini-css-extract-plugin
export default {"Dashboard":"styles_Dashboard__MPzNB"};